export const LOAD_DASHBOARD_CONFIGS = 'EPIC/LOAD_DASHBOARD_CONFIGS';
export const LOAD_DASHBOARD_CONFIGS_SUCCESS = 'EPIC/LOAD_DASHBOARD_CONFIGS_SUCCESS';
export const LOAD_DASHBOARD_CONFIGS_FAILURE = 'EPIC/LOAD_DASHBOARD_CONFIGS_FAILURE';
